var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Title',{attrs:{"title":"Lista de Endereços"}}),_c('b-table',{attrs:{"fields":_vm.tabela.fields,"items":_vm.enderecos,"empty-text":_vm.$t('GERAL.NENHUM_REGISTRO'),"head-variant":"light","stacked":"md","show-empty":"","responsive":"","striped":"","hover":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }